<template>
    <section class="signup-section spad set-bg">
        <div class="signup-warp d-flex">
            <!-- signup form -->
            <div class="signup-container ml-auto mr-auto mt-sm-5">
                <form class="signup-form m-3 m-sm-0 pt-5" v-if="!registerSuccessful" v-on:submit.prevent="register">
                    <p class="h2 mb-4">Regístrate</p>
                    <!-- <input type="text" name="name" id="name" :class="{'margin-zero': errors.has('name')}" placeholder="Nombre" v-model="user.name" v-validate="'required'" >
                    <p class="form-error" v-show="errors.has('name')">{{ errors.first('name') }}</p> -->
                    <input type="email" name="correo" id="correo" :class="{'margin-zero': errors.has('correo')}" placeholder="Correo electrónico" v-model="user.email" v-validate="'required'">
                    <p class="form-error" v-show="errors.has('correo')">{{ errors.first('correo') }}</p>
                    <input type="password" name="password" id="password" :class="{'margin-zero': errors.has('password')}" placeholder="Contraseña" v-model="user.password" v-validate="{ required: true, regex: /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/ }">
                    <p class="form-error" v-show="errors.has('password')">{{ errors.first('password') }}</p>
                    <input type="password" name="repeatPassword" id="repeatPassword" :class="{'margin-zero': errors.has('repeatPassword')}" placeholder="Repetir contraseña" v-model="repeatPassword" v-validate="'required|samePassword'" data-vv-as="Repetir contraseña">
                    <p class="form-error" v-show="errors.has('repeatPassword')">{{ errors.first('repeatPassword') }}</p>
                    <vue-recaptcha id="captcha" sitekey="6LfCJuIZAAAAALtujhJ0zzJ5_Jn6RuzIjtfJaRWz" :loadRecaptchaScript="true" @verify="isVerified = true" @expired="isVerified = false"></vue-recaptcha>
                    <input type="submit" value="Registrarse" class="site-btn" v-if="!loading" :disabled="!isVerified">
                    <div class="loader-container" v-else>
                        <div class="loader"></div>
                    </div>
                    <p v-if="errorMsg" class="api-error">{{errorMsg}}</p>
                </form>
                <div class="signup-form" v-else>
                    <div class="text-left mb-4">
                        <h4>¡Ya te has registrado!</h4>
                    </div>
                    <div class="text-left text-muted mb-4">Se ha enviado un email de verificación a tu dirección de correo electrónico. Haz click en el enlace de validación para tener acceso online a tus cursos Chachi Guitar. Sí, también podrás descargarlos.</div>
                </div>
            </div>
        </div>
	</section>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import messagesEs from 'vee-validate/dist/locale/es.js';
import VueRecaptcha from 'vue-recaptcha';

import { API_URL } from '@/config.js'

Vue.use(VeeValidate, {
    locale: 'es',
    events: 'blur',
    dictionary: {
        es: messagesEs
    }
});

Validator.localize('es', { 
    custom: {
        correo: {
            email: 'Debes introducir un correo electrónico válido',
            required: 'El campo correo electrónico es obligatorio'
        },
        // name: {
        //     required: 'El campo nombre es obligatorio'
        // },
        password: {
            required: 'Debes introducir una contraseña',
            regex: 'La contraseña debe tener como mínimo 8 caracteres y debe incluir al menos una mayúscula, una minúscula y un número'
        },
        repeatPassword: {
            required: 'Debes introducir de nuevo la contraseña'
        }
    }
});

export default {
    name: 'register',
    components: { VueRecaptcha },
    data() {
        return {
            user: {
                name: null,
                email: null,
                password: null,
                rol_id: "08d71af7-baf8-122b-37e3-04a89a91c2ff"
            },
            repeatPassword: null,
            errorMsg: null,
            loading: false,
            registerSuccessful: false,
            isVerified: false
        }
    },
    created() {
        this.$validator.extend('samePassword', {
            getMessage: 'Las contraseñas deben coincidir',
            validate: value => {
                return value && value != '' && value == this.user.password
            }
        });
    },
    methods: {
        register() {
            this.loading = true;
            this.errorMsg = null;
            this.$validator.validate().then(valid => {
                if (valid && this.isVerified) {
                    axios.post(`${API_URL}/public/user/register`, this.user)
                        .then(response => {
                            this.loading = false;
                            console.log(response)
                            if (response.status == 201) {
                                this.registerSuccessful = true;
                            } else {
                                this.errorMsg = "Se ha producido un error al realizar el registro. Inténtalo de nuevo en unos minutos.";
                            }
                        })
                        .catch((error) => {
                            console.log(error.response.data.Message)
                            this.loading = false;
                            if (error.response.data.Message == "Duplicated Email Address") {
                                this.errorMsg = "Ya existe una cuenta con esa dirección de email. Inicia sesión para acceder a tus cursos.";
                            } else {
                                this.errorMsg = "Se ha producido un error al realizar el registro. Inténtalo de nuevo en unos minutos.";
                            }
                        });
                } else {
                    this.loading = false;
                    if (valid && !this.isVerified) {
                        this.isVerified = false;
                        this.errorMsg = "Por favor, verifica el captcha para comprobar que no eres un robot.";
                    }
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/variables.scss";
    .signup-section {
        min-height: calc(100vh - 48px);
        padding-top: $header-unauth-height;
        background-color: $main-color-brown;
        background-image: url("https://www.justcompileit.com/videos/cursos-streaming/images/register.jpg");
        .signup-container {
            width: 100vw;
            max-width: 700px;
            box-sizing: border-box;
        }
        .signup-form {
            input[type=password] {
                height: 57px;
                width: 100%;
                padding: 0 30px;
                margin-bottom: 27px;
                float: left;
                border: none;
                font-size: 14px;
                font-weight: 500;
                background: #edf4f6;
            }
            input.margin-zero {
                margin-bottom: 4px;
                background:#ffdfdf !important;
            }
            .form-error {
                display: inherit;
                text-align: left;
                color: red;
                margin-left: 10px;
                margin-bottom: 8px;
                line-height: 16px;
            }
            .api-error {
                color: red;
                margin: 15px 10px -10px;
                font-size: 16px;
                line-height: 20px;
            }
            #captcha {
                display: table;
                margin: auto;
                margin-bottom: 20px;
            }
        }
    }
</style>

